import React, { Component } from 'react'
import DocumentTitle from 'react-document-title'
import { extendObservable } from 'mobx'
import { observer } from 'mobx-react'
import Header from '@components/Details/Header'
import Spinner from '@components/spinner'

import AtheneumOfficeStore from './atheneum-office.store'
import AtheneumOfficeTable from './AtheneumOfficeTable'

class AtheneumOfficePage extends Component {
  constructor (props) {
    super(props)

    extendObservable(this, {
      atheneumOfficeStore: new AtheneumOfficeStore()
    })

    this.atheneumOfficeStore.init()
  }

  render () {
    const { loading } = this.atheneumOfficeStore

    if (loading) {
      return <Spinner />
    }

    return (
      <DocumentTitle title='Atheneum Offices | Atheneum Partners'>
        <div>
          <div className='expert-search'>
            <div className='project-wrapper atheneum-office-wrapper'>
              <Header>
                <div className='info info--noLeft'>
                  <div className='name-status-wrapper'>
                    <h1>Atheneum Companies</h1>
                  </div>
                </div>
              </Header>
              <AtheneumOfficeTable
                atheneumOfficeStore={this.atheneumOfficeStore}
              />
            </div>
          </div>
        </div>
      </DocumentTitle>
    )
  }
}

export default observer(AtheneumOfficePage)
